import { RouteConfig } from 'vue-router';
import Form from '@/views/layout/Form.vue';
import i18n from '@/i18n';

const routes: Array<RouteConfig> = [
  {
    path: 'health_profession_field',
    name: 'health-profession-field',
    component: Form,
    redirect: { name: 'health-profession-field-list' },
    meta: {
      session: true,
    },
    children: [
      {
        path: 'list',
        name: 'health-profession-field-list',
        component: () =>
          import('@/views/healthProfessionField/HealthProfessionFieldList.vue'),
        meta: {
          header: {
            label: () =>
              i18n.t('title.list', [i18n.tc('healthProfessionField.label', 2)]),
          },
        },
      },
      {
        path: 'create',
        name: 'health-profession-field-create',
        component: () =>
          import(
            '@/views/healthProfessionField/HealthProfessionFieldCreate.vue'
          ),
        meta: {
          header: {
            route: { name: 'health-profession-field-list' },
            label: () =>
              i18n.t('title.create', [
                i18n.tc('healthProfessionField.label', 2),
              ]),
          },
        },
      },
      {
        path: 'edit/:id(\\d+)',
        name: 'health-profession-field-edit',
        component: () =>
          import('@/views/healthProfessionField/HealthProfessionFieldEdit.vue'),
        meta: {
          header: {
            route: { name: 'health-profession-field-list' },
            label: () =>
              i18n.t('title.edit', [i18n.tc('healthProfessionField.label', 2)]),
          },
        },
      },
    ],
  },
];

export default routes;
